import { defineMessages } from 'react-intl';

export default defineMessages({
  owner: {
    id: 'view.file.tabs.summary.holder.owner',
    defaultMessage: 'Owner',
  },
  repairerWorkshop: {
    id: 'view.file.tabs.summary.holder.repairerWorkshop',
    defaultMessage: 'Repairer workshop',
  },
  repairerHub: {
    id: 'view.file.tabs.summary.holder.repairerHub',
    defaultMessage: 'Repairer hub',
  },
  repairerPartner: {
    id: 'view.file.tabs.summary.holder.repairerPartner',
    defaultMessage: 'Repairer partner',
  },
  supplier: {
    id: 'view.file.tabs.summary.holder.supplier',
    defaultMessage: 'Supplier',
  },
  store: {
    id: 'view.file.tabs.summary.holder.store',
    defaultMessage: 'Store',
  },
  carrier: {
    id: 'view.file.tabs.summary.holder.carrier',
    defaultMessage: 'Carrier',
  },
  externalCarrier: {
    id: 'view.file.tabs.summary.holder.externalCarrier',
    defaultMessage: 'External carrier',
  },
  warehouse: {
    id: 'view.file.tabs.summary.holder.warehouse',
    defaultMessage: 'Warehouse',
  },
});
